import styled from "styled-components";
import { isMobileDevice } from "./utils/common";

const isMobile = isMobileDevice();

export const BodyWrappers = styled.div`
  height: ${isMobile ? `${window.innerHeight}px` : "100vh"};
  width: 480px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  box-shadow: 0px 0px 250px rgba(0, 0, 0, 0.06);
  margin: 0 auto;

  @media (max-width: 479px) {
    width: 100%;
  }
`;

  // height: ${(props) => props.footer === true ? 'calc(100% - 80px)' : '100%'};
export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  overflow: auto;
  padding: ${(props) => "0 32px " + (props.footer ? 88 : 32).toString() + "px 32px"};

  @media (max-width: 359px) {
    padding: 0 16px 88px 16px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  position: relative;
`;
